<template>
    <CTable
        v-if="data.page"
        :isLoading="isLoading"
        v-model:columns="data.columns"
        v-model:page="data.page"
        :options="data.tableOptions"
        :manages="data.manages"
        :manageExtras="data.manageExtras"
        :rowActions="data.rowActions"
        :clientSide="true"
        :canRefresh="false"
        :visibleSearch="false"
        :visiblePagination="false"
    ></CTable>
    <div class="has-error" v-if="data.useForm.validateInfos[itemsKey]?.validateStatus === 'error'">
        <div class="ant-form-explain">
            {{ data.useForm.validateInfos[itemsKey]?.help }}
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../app.logic";
import { initData, isLoading } from "./fee-statement-inline.logic";

export default defineComponent({
    components: {
        CTable: defineAsyncComponent(() => import("../../../../components/table/CTable"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false },
        dataProp: {},
        itemsKey: {},
        fetchCriteria: {},
        canCreate: {},
        canDelete: {},
        group: {}
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        initData({ props, data, refs });
        return { props, data, refs, isLoading };
    }
});
</script>
